var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge text-center",class:_vm.cssClass},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }